var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VContentCard',[_c('template',{slot:"form"},[_c('ResetPasswordScreenForm',{attrs:{"token":_vm.token}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }